import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';

export const customFieldOptionProjectLimitMetricDetailEntryPoint: ReturnType<
	typeof createPageEntryPoint
> = createPageEntryPoint({
	main: {
		root: JSResourceForInteraction(
			() =>
				import(
					/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-custom-field-option-project-limit" */ '@jira/spa-apps__admin-pages-performance-metric-detail-custom-field-option-project-limit/src/CustomFieldOptionProjectLimitDetail.tsx'
				),
		),
		getPreloadProps: () => ({}),
	},
});
